// This file is auto-generated by @hey-api/openapi-ts

import { client, type Options, formDataBodySerializer } from '@hey-api/client-fetch';
import { type GetDocumentsAttachmentsDocumenttypeDocumentidData, type GetDocumentsAttachmentsDocumenttypeDocumentidError, type GetDocumentsAttachmentsDocumenttypeDocumentidResponse, type PostDocumentsAttachmentsDocumenttypeDocumentidData, type PostDocumentsAttachmentsDocumenttypeDocumentidError, type PostDocumentsAttachmentsDocumenttypeDocumentidResponse, type PostDocumentsBulkInsertDocumenttypeDocumentidData, type PostDocumentsBulkInsertDocumenttypeDocumentidError, type PostDocumentsBulkInsertDocumenttypeDocumentidResponse, type GetDocumentsDefinitionDocumentnameData, type GetDocumentsDefinitionDocumentnameError, type GetDocumentsDefinitionDocumentnameResponse, type GetDocumentsDetailsDocumenttypeDocumentidData, type GetDocumentsDetailsDocumenttypeDocumentidError, type GetDocumentsDetailsDocumenttypeDocumentidResponse, type PostDocumentsExportDocumenttypeDocumentidData, type PostDocumentsExportDocumenttypeDocumentidError, type PostDocumentsExportDocumenttypeDocumentidResponse, type GetDocumentsExportPendingHeaderidData, type GetDocumentsExportPendingHeaderidError, type GetDocumentsExportPendingHeaderidResponse, type GetDocumentsItemLookupDocumenttypeData, type GetDocumentsItemLookupDocumenttypeError, type GetDocumentsItemLookupDocumenttypeResponse, type GetDocumentsItemPriceDocumenttypeItemidData, type GetDocumentsItemPriceDocumenttypeItemidError, type GetDocumentsItemPriceDocumenttypeItemidResponse, type GetDocumentsNotesDocumenttypeDocumentidData, type GetDocumentsNotesDocumenttypeDocumentidError, type GetDocumentsNotesDocumenttypeDocumentidResponse, type PostDocumentsNotesDocumenttypeDocumentidData, type PostDocumentsNotesDocumenttypeDocumentidError, type PostDocumentsNotesDocumenttypeDocumentidResponse, type DeleteDocumentsNotesNoteidData, type DeleteDocumentsNotesNoteidError, type DeleteDocumentsNotesNoteidResponse, type GetDocumentsQueuesDocumenttypeData, type GetDocumentsQueuesDocumenttypeError, type GetDocumentsQueuesDocumenttypeResponse, type GetDocumentsSearchData, type GetDocumentsSearchError, type GetDocumentsSearchResponse, type GetDocumentsStorageKeyData, type PostDocumentsStorageKeyData, type PostDocumentsTagsDocumenttypeDocumentidData, type PostDocumentsTagsDocumenttypeDocumentidError, type PostDocumentsTagsDocumenttypeDocumentidResponse, GetDocumentsAttachmentsDocumenttypeDocumentidResponseTransformer, GetDocumentsNotesDocumenttypeDocumentidResponseTransformer, PostDocumentsNotesDocumenttypeDocumentidResponseTransformer, GetDocumentsQueuesDocumenttypeResponseTransformer, GetDocumentsSearchResponseTransformer, type PostInventoryCatalogIdUpsertData, type PostInventoryCatalogIdUpsertError, type PostInventoryCatalogIdUpsertResponse, type GetInventoryCategoriesError, type GetInventoryCategoriesResponse, type PostInventoryCategoriesData, type PostInventoryCategoriesError, type PostInventoryCategoriesResponse, type PostInventoryCategoriesIdData, type PostInventoryCategoriesIdError, type PostInventoryCategoriesIdResponse, type PostInventoryItemData, type PostInventoryItemError, type PostInventoryItemResponse, type GetInventoryItemLabelsDocumenttypeDocumentidData, type GetInventoryItemLabelsDocumenttypeDocumentidError, type GetInventoryItemLabelsDocumenttypeDocumentidResponse, type PostInventoryItemLabelsDocumenttypeDocumentidData, type PostInventoryItemLabelsDocumenttypeDocumentidError, type PostInventoryItemLabelsDocumenttypeDocumentidResponse, type GetInventoryItemLookupItemskuData, type GetInventoryItemLookupItemskuError, type GetInventoryItemLookupItemskuResponse, type GetInventoryItemTagListError, type GetInventoryItemTagListResponse, type GetInventoryItemItemskuData, type GetInventoryItemItemskuError, type GetInventoryItemItemskuResponse, type GetInventoryItemItemskuBatchesData, type GetInventoryItemItemskuBatchesError, type GetInventoryItemItemskuBatchesResponse, type PostInventoryItemItemskuContactContactcodeData, type PostInventoryItemItemskuContactContactcodeError, type PostInventoryItemItemskuContactContactcodeResponse, type PostInventoryItemItemskuIdentifierData, type PostInventoryItemItemskuIdentifierError, type PostInventoryItemItemskuIdentifierResponse, type GetInventoryItemItemskuImagesData, type GetInventoryItemItemskuImagesError, type GetInventoryItemItemskuImagesResponse, type PostInventoryItemItemskuImagesData, type PostInventoryItemItemskuImagesError, type PostInventoryItemItemskuImagesResponse, type GetInventoryItemItemskuInventoryData, type GetInventoryItemItemskuInventoryError, type GetInventoryItemItemskuInventoryResponse, type GetInventoryItemItemskuInventory3DData, type GetInventoryItemItemskuInventory3DError, type GetInventoryItemItemskuInventory3DResponse, type GetInventoryItemItemskuInventoryLogData, type GetInventoryItemItemskuInventoryLogError, type GetInventoryItemItemskuInventoryLogResponse, type GetInventoryItemItemskuInventoryDrilldownWarehouseidData, type GetInventoryItemItemskuInventoryDrilldownWarehouseidError, type GetInventoryItemItemskuInventoryDrilldownWarehouseidResponse, type GetInventoryItemItemskuPricingData, type GetInventoryItemItemskuPricingError, type GetInventoryItemItemskuPricingResponse, type GetInventoryItemItemskuQuickViewQvtypeData, type GetInventoryItemItemskuQuickViewQvtypeError, type GetInventoryItemItemskuQuickViewQvtypeResponse, type GetInventoryItemItemskuUomData, type GetInventoryItemItemskuUomError, type GetInventoryItemItemskuUomResponse, type PostInventoryItemItemskuVendorContactcodeData, type PostInventoryItemItemskuVendorContactcodeError, type PostInventoryItemItemskuVendorContactcodeResponse, type PostInventoryItemImagesData, type PostInventoryItemImagesError, type PostInventoryItemImagesResponse, type GetInventoryItemListData, type GetInventoryItemListError, type GetInventoryItemListResponse, type PatchInventoryItemTagsData, type PatchInventoryItemTagsError, type PatchInventoryItemTagsResponse, type GetInventoryPriceListIdData, type GetInventoryPriceListIdError, type GetInventoryPriceListIdResponse, type GetInventoryPriceListListError, type GetInventoryPriceListListResponse, type PostInventoryPriceListUpsertConditionalData, type PostInventoryPriceListUpsertConditionalError, type PostInventoryPriceListUpsertConditionalResponse, type PostInventoryPriceListUpsertEntriesData, type PostInventoryPriceListUpsertEntriesError, type PostInventoryPriceListUpsertEntriesResponse, type PostInventoryPriceListUpsertUomData, type PostInventoryPriceListUpsertUomError, type PostInventoryPriceListUpsertUomResponse, type PostInventoryPrintItemData, type PostInventoryPrintItemError, type PostInventoryPrintItemResponse, type PostInventoryPrintItemBulkData, type PostInventoryPrintItemBulkError, type PostInventoryPrintItemBulkResponse, type GetInventoryStockSummaryData, type GetInventoryStockSummaryError, type GetInventoryStockSummaryResponse, type GetInventoryStockSummaryDetailedData, type GetInventoryStockSummaryDetailedError, type GetInventoryStockSummaryDetailedResponse, type PostInventoryTrcData, type PostInventoryTrcError, type PostInventoryTrcResponse, type PostInventoryTrnData, type PostInventoryTrnError, type PostInventoryTrnResponse, type GetInventoryWarehousesData, type GetInventoryWarehousesError, type GetInventoryWarehousesResponse, type PostInventoryWarehousesWarehouseidBinData, type PostInventoryWarehousesWarehouseidBinError, type PostInventoryWarehousesWarehouseidBinResponse, type GetInventoryWarehousesWarehouseidBinListData, type GetInventoryWarehousesWarehouseidBinListError, type GetInventoryWarehousesWarehouseidBinListResponse, type DeleteInventoryWarehousesWarehouseidBinBinidData, type DeleteInventoryWarehousesWarehouseidBinBinidError, type DeleteInventoryWarehousesWarehouseidBinBinidResponse, type GetInventoryWarehousesWarehouseidBinsData, type GetInventoryWarehousesWarehouseidBinsError, type GetInventoryWarehousesWarehouseidBinsResponse, type PostInventoryWarehousesWarehouseidZoneData, type PostInventoryWarehousesWarehouseidZoneError, type PostInventoryWarehousesWarehouseidZoneResponse, type DeleteInventoryWarehousesWarehouseidZoneZoneidData, type DeleteInventoryWarehousesWarehouseidZoneZoneidError, type DeleteInventoryWarehousesWarehouseidZoneZoneidResponse, type GetInventoryWarehousesWarehouseidZonesData, type GetInventoryWarehousesWarehouseidZonesError, type GetInventoryWarehousesWarehouseidZonesResponse, PostInventoryItemResponseTransformer, GetInventoryItemLabelsDocumenttypeDocumentidResponseTransformer, GetInventoryItemItemskuResponseTransformer, GetInventoryItemItemskuBatchesResponseTransformer, GetInventoryItemItemskuInventory3DResponseTransformer, GetInventoryItemItemskuInventoryLogResponseTransformer, GetInventoryItemItemskuInventoryDrilldownWarehouseidResponseTransformer, GetInventoryItemItemskuPricingResponseTransformer, GetInventoryItemItemskuQuickViewQvtypeResponseTransformer, GetInventoryPriceListIdResponseTransformer, GetInventoryStockSummaryResponseTransformer, GetInventoryStockSummaryDetailedResponseTransformer, GetInventoryWarehousesWarehouseidBinsResponseTransformer, type GetReportsCustomFeedIdKeyData, type GetReportsCustomFeedIdKeyError, type GetReportsCustomFeedIdKeyResponse, type GetReportsKpiDashboardError, type GetReportsKpiDashboardResponse, type PostReportsKpiDashboardData, type PostReportsKpiDashboardError, type PostReportsKpiDashboardResponse, type PostReportsKpiDashboardDashboardidWidgetData, type PostReportsKpiDashboardDashboardidWidgetError, type PostReportsKpiDashboardDashboardidWidgetResponse, type PostReportsKpiDashboardDashboardidWidgetWidgetidData, type PostReportsKpiDashboardDashboardidWidgetWidgetidError, type PostReportsKpiDashboardDashboardidWidgetWidgetidResponse, type DeleteReportsKpiDashboardDashboardidWidgetWidgetidData, type DeleteReportsKpiDashboardDashboardidWidgetWidgetidError, type DeleteReportsKpiDashboardDashboardidWidgetWidgetidResponse, type GetReportsKpiDashboardDashboardidWidgetsData, type GetReportsKpiDashboardDashboardidWidgetsError, type GetReportsKpiDashboardDashboardidWidgetsResponse, type PutReportsKpiDashboardIdData, type PutReportsKpiDashboardIdError, type PutReportsKpiDashboardIdResponse, type DeleteReportsKpiDashboardIdData, type DeleteReportsKpiDashboardIdError, type DeleteReportsKpiDashboardIdResponse, type GetReportsKpiDashboardTokenData, type GetReportsKpiDashboardTokenError, type GetReportsKpiDashboardTokenResponse, type GetReportsKpiDashboardTokenValueWidgetidData, type GetReportsKpiDashboardTokenValueWidgetidError, type GetReportsKpiDashboardTokenValueWidgetidResponse, type PutReportsKpiDashboardTokenWidgetsData, type PutReportsKpiDashboardTokenWidgetsError, type PutReportsKpiDashboardTokenWidgetsResponse, type GetReportsKpiDashboardListWidgetTypesError, type GetReportsKpiDashboardListWidgetTypesResponse, type GetReportsListTypesError, type GetReportsListTypesResponse, type GetReportsReportServerItemsData, type GetReportsReportServerItemsError, type GetReportsReportServerItemsResponse, type GetReportsReportServerSalesData, type GetReportsReportServerSalesError, type GetReportsReportServerSalesResponse, type PostReportsRunReportData, type PostReportsRunReportError, type PostReportsRunReportResponse, type GetReportsSalesDrillDownItemskuData, type GetReportsSalesDrillDownItemskuError, type GetReportsSalesDrillDownItemskuResponse, type GetReportsSalesOverviewPerformanceSectionData, type GetReportsSalesOverviewPerformanceSectionError, type GetReportsSalesOverviewPerformanceSectionResponse, type GetReportsSalesOverviewPerformanceDailyData, type GetReportsSalesOverviewPerformanceDailyError, type GetReportsSalesOverviewPerformanceDailyResponse, type GetReportsSalesOverviewPerformanceItemsData, type GetReportsSalesOverviewPerformanceItemsError, type GetReportsSalesOverviewPerformanceItemsResponse, type GetReportsSalesOverviewSummaryData, type GetReportsSalesOverviewSummaryError, type GetReportsSalesOverviewSummaryResponse, type GetReportsSalesOverviewSummaryRangeData, type GetReportsSalesOverviewSummaryRangeError, type GetReportsSalesOverviewSummaryRangeResponse, type GetReportsSchedulesError, type GetReportsSchedulesResponse, type PostReportsSchedulesData, type PostReportsSchedulesError, type PostReportsSchedulesResponse, type GetReportsSchedulesIdData, type GetReportsSchedulesIdError, type GetReportsSchedulesIdResponse, type PatchReportsSchedulesIdData, type PatchReportsSchedulesIdError, type PatchReportsSchedulesIdResponse, type DeleteReportsSchedulesIdData, type DeleteReportsSchedulesIdError, type DeleteReportsSchedulesIdResponse, type GetReportsSoCustomerPeriodicSoidData, type GetReportsSoCustomerPeriodicSoidError, type GetReportsSoCustomerPeriodicSoidResponse, type PutReportsSystemAlertsDismissGroupData, type PutReportsSystemAlertsDismissGroupError, type PutReportsSystemAlertsDismissGroupResponse, type PutReportsSystemAlertsDismissMessageData, type PutReportsSystemAlertsDismissMessageError, type PutReportsSystemAlertsDismissMessageResponse, type GetReportsSystemAlertsGroupsError, type GetReportsSystemAlertsGroupsResponse, type GetReportsSystemAlertsMessagesData, type GetReportsSystemAlertsMessagesError, type GetReportsSystemAlertsMessagesResponse, GetReportsSalesDrillDownItemskuResponseTransformer, GetReportsSalesOverviewSummaryRangeResponseTransformer, GetReportsSchedulesResponseTransformer, GetReportsSchedulesIdResponseTransformer, GetReportsSoCustomerPeriodicSoidResponseTransformer, GetReportsSystemAlertsGroupsResponseTransformer, GetReportsSystemAlertsMessagesResponseTransformer, type GetSettingsApiUsersError, type GetSettingsApiUsersResponse, type GetSettingsCurrencyListError, type GetSettingsCurrencyListResponse, type GetSettingsDocumentCustomFieldData, type GetSettingsDocumentCustomFieldError, type GetSettingsDocumentCustomFieldResponse, type GetSettingsDocumentStageListError, type GetSettingsDocumentStageListResponse, type PostSettingsDocumentTagData, type PostSettingsDocumentTagError, type PostSettingsDocumentTagResponse, type PutSettingsDocumentTagIdData, type PutSettingsDocumentTagIdError, type PutSettingsDocumentTagIdResponse, type GetSettingsDocumentTagListError, type GetSettingsDocumentTagListResponse, type GetUserDataColumnsViewnameData, type GetUserDataColumnsViewnameError, type GetUserDataColumnsViewnameResponse, type PostUserEmailValidationRequestError, type PostUserEmailValidationRequestResponse, type GetUserNotificationsData, type GetUserNotificationsError, type GetUserNotificationsResponse, type GetUserNotificationsCountError, type GetUserNotificationsCountResponse, type GetUserOrganizationError, type GetUserOrganizationResponse, type GetUserSelfError, type GetUserSelfResponse, type PostUserSupportTicketData, type PostUserSupportTicketError, type PostUserSupportTicketResponse, type GetUserSupportTicketTicketidData, type GetUserSupportTicketTicketidError, type GetUserSupportTicketTicketidResponse, type GetUserSupportTicketListData, type GetUserSupportTicketListError, type GetUserSupportTicketListResponse, GetUserNotificationsResponseTransformer, GetUserSupportTicketTicketidResponseTransformer, GetUserSupportTicketListResponseTransformer } from './types.gen';

export class DocumentsService {
    /**
     * 🔒  [DOC04] List document attachments
     */
    public static getDocumentsAttachmentsDocumenttypeDocumentid(options: Options<GetDocumentsAttachmentsDocumenttypeDocumentidData>) {
        return (options?.client ?? client).get<GetDocumentsAttachmentsDocumenttypeDocumentidResponse, GetDocumentsAttachmentsDocumenttypeDocumentidError>({
            ...options,
            url: '/documents/attachments/{documentType}/{documentId}',
            responseTransformer: GetDocumentsAttachmentsDocumenttypeDocumentidResponseTransformer
        });
    }
    
    /**
     * 🔒  [DOC05] Create document attachment
     */
    public static postDocumentsAttachmentsDocumenttypeDocumentid(options: Options<PostDocumentsAttachmentsDocumenttypeDocumentidData>) {
        return (options?.client ?? client).post<PostDocumentsAttachmentsDocumenttypeDocumentidResponse, PostDocumentsAttachmentsDocumenttypeDocumentidError>({
            ...options,
            ...formDataBodySerializer,
            url: '/documents/attachments/{documentType}/{documentId}'
        });
    }
    
    /**
     * 🔒  [DOC22] Bulk insert
     */
    public static postDocumentsBulkInsertDocumenttypeDocumentid(options: Options<PostDocumentsBulkInsertDocumenttypeDocumentidData>) {
        return (options?.client ?? client).post<PostDocumentsBulkInsertDocumenttypeDocumentidResponse, PostDocumentsBulkInsertDocumenttypeDocumentidError>({
            ...options,
            url: '/documents/bulk-insert/{documentType}/{documentId}'
        });
    }
    
    /**
     *  [DOC10]
     */
    public static getDocumentsDefinitionDocumentname(options: Options<GetDocumentsDefinitionDocumentnameData>) {
        return (options?.client ?? client).get<GetDocumentsDefinitionDocumentnameResponse, GetDocumentsDefinitionDocumentnameError>({
            ...options,
            url: '/documents/definition/{documentName}'
        });
    }
    
    /**
     * 🔒  [DOC01] Retrieve document details
     */
    public static getDocumentsDetailsDocumenttypeDocumentid(options: Options<GetDocumentsDetailsDocumenttypeDocumentidData>) {
        return (options?.client ?? client).get<GetDocumentsDetailsDocumenttypeDocumentidResponse, GetDocumentsDetailsDocumenttypeDocumentidError>({
            ...options,
            url: '/documents/details/{documentType}/{documentId}'
        });
    }
    
    /**
     * 🔒  [DOC09] Mark document export
     */
    public static postDocumentsExportDocumenttypeDocumentid(options: Options<PostDocumentsExportDocumenttypeDocumentidData>) {
        return (options?.client ?? client).post<PostDocumentsExportDocumenttypeDocumentidResponse, PostDocumentsExportDocumenttypeDocumentidError>({
            ...options,
            url: '/documents/export/{documentType}/{documentId}'
        });
    }
    
    /**
     * 🔒  [DOC03] Retrieve list of pending export documents
     */
    public static getDocumentsExportPendingHeaderid(options: Options<GetDocumentsExportPendingHeaderidData>) {
        return (options?.client ?? client).get<GetDocumentsExportPendingHeaderidResponse, GetDocumentsExportPendingHeaderidError>({
            ...options,
            url: '/documents/export/pending/{headerId}'
        });
    }
    
    /**
     * 🔒  [DOC23] Document Item lookup
     */
    public static getDocumentsItemLookupDocumenttype(options: Options<GetDocumentsItemLookupDocumenttypeData>) {
        return (options?.client ?? client).get<GetDocumentsItemLookupDocumenttypeResponse, GetDocumentsItemLookupDocumenttypeError>({
            ...options,
            url: '/documents/item-lookup/{documentType}'
        });
    }
    
    /**
     * 🔒  [DOC24] Document Item price lookup
     */
    public static getDocumentsItemPriceDocumenttypeItemid(options: Options<GetDocumentsItemPriceDocumenttypeItemidData>) {
        return (options?.client ?? client).get<GetDocumentsItemPriceDocumenttypeItemidResponse, GetDocumentsItemPriceDocumenttypeItemidError>({
            ...options,
            url: '/documents/item-price/{documentType}/{itemId}'
        });
    }
    
    /**
     * 🔒  [DOC06] List document notes
     */
    public static getDocumentsNotesDocumenttypeDocumentid(options: Options<GetDocumentsNotesDocumenttypeDocumentidData>) {
        return (options?.client ?? client).get<GetDocumentsNotesDocumenttypeDocumentidResponse, GetDocumentsNotesDocumenttypeDocumentidError>({
            ...options,
            url: '/documents/notes/{documentType}/{documentId}',
            responseTransformer: GetDocumentsNotesDocumenttypeDocumentidResponseTransformer
        });
    }
    
    /**
     * 🔒  [DOC07] Create document note
     */
    public static postDocumentsNotesDocumenttypeDocumentid(options: Options<PostDocumentsNotesDocumenttypeDocumentidData>) {
        return (options?.client ?? client).post<PostDocumentsNotesDocumenttypeDocumentidResponse, PostDocumentsNotesDocumenttypeDocumentidError>({
            ...options,
            url: '/documents/notes/{documentType}/{documentId}',
            responseTransformer: PostDocumentsNotesDocumenttypeDocumentidResponseTransformer
        });
    }
    
    /**
     * 🔒  [DOC08] Delete document note
     */
    public static deleteDocumentsNotesNoteid(options: Options<DeleteDocumentsNotesNoteidData>) {
        return (options?.client ?? client).delete<DeleteDocumentsNotesNoteidResponse, DeleteDocumentsNotesNoteidError>({
            ...options,
            url: '/documents/notes/{noteId}'
        });
    }
    
    /**
     * 🔒  [DOC30] Document queues
     */
    public static getDocumentsQueuesDocumenttype(options: Options<GetDocumentsQueuesDocumenttypeData>) {
        return (options?.client ?? client).get<GetDocumentsQueuesDocumenttypeResponse, GetDocumentsQueuesDocumenttypeError>({
            ...options,
            url: '/documents/queues/{documentType}',
            responseTransformer: GetDocumentsQueuesDocumenttypeResponseTransformer
        });
    }
    
    /**
     * 🔒  [DOC02] Search documents
     */
    public static getDocumentsSearch(options: Options<GetDocumentsSearchData>) {
        return (options?.client ?? client).get<GetDocumentsSearchResponse, GetDocumentsSearchError>({
            ...options,
            url: '/documents/search',
            responseTransformer: GetDocumentsSearchResponseTransformer
        });
    }
    
    /**
     * 🔒  [DOC20] Retrieve storage object
     */
    public static getDocumentsStorageKey(options: Options<GetDocumentsStorageKeyData>) {
        return (options?.client ?? client).get<void>({
            ...options,
            url: '/documents/storage/{key}'
        });
    }
    
    /**
     * 🔒  [DOC21] Save storage object
     */
    public static postDocumentsStorageKey(options: Options<PostDocumentsStorageKeyData>) {
        return (options?.client ?? client).post<void>({
            ...options,
            url: '/documents/storage/{key}'
        });
    }
    
    /**
     * 🔒  [DOC31] Document tags update
     */
    public static postDocumentsTagsDocumenttypeDocumentid(options: Options<PostDocumentsTagsDocumenttypeDocumentidData>) {
        return (options?.client ?? client).post<PostDocumentsTagsDocumenttypeDocumentidResponse, PostDocumentsTagsDocumenttypeDocumentidError>({
            ...options,
            url: '/documents/tags/{documentType}/{documentId}'
        });
    }
    
}

export class InventoryService {
    /**
     * 🔒  [INV38] Catalog Items update
     */
    public static postInventoryCatalogIdUpsert(options: Options<PostInventoryCatalogIdUpsertData>) {
        return (options?.client ?? client).post<PostInventoryCatalogIdUpsertResponse, PostInventoryCatalogIdUpsertError>({
            ...options,
            url: '/inventory/catalog/{id}/upsert'
        });
    }
    
    /**
     * 🔒  [INVCT01] Item category - List
     */
    public static getInventoryCategories(options?: Options) {
        return (options?.client ?? client).get<GetInventoryCategoriesResponse, GetInventoryCategoriesError>({
            ...options,
            url: '/inventory/categories'
        });
    }
    
    /**
     * 🔒  [INVCT02] Item category - Upsert
     */
    public static postInventoryCategories(options: Options<PostInventoryCategoriesData>) {
        return (options?.client ?? client).post<PostInventoryCategoriesResponse, PostInventoryCategoriesError>({
            ...options,
            url: '/inventory/categories'
        });
    }
    
    /**
     * 🔒  [INVCT02] Item category - Upsert
     */
    public static postInventoryCategoriesId(options: Options<PostInventoryCategoriesIdData>) {
        return (options?.client ?? client).post<PostInventoryCategoriesIdResponse, PostInventoryCategoriesIdError>({
            ...options,
            url: '/inventory/categories/{id}'
        });
    }
    
    /**
     * 🔒  [INV15] List item divisions
     */
    public static getInventoryDivisions(options?: Options) {
        return (options?.client ?? client).get<void>({
            ...options,
            url: '/inventory/divisions'
        });
    }
    
    /**
     * 🔒  [INV09] Create new item
     */
    public static postInventoryItem(options?: Options<PostInventoryItemData>) {
        return (options?.client ?? client).post<PostInventoryItemResponse, PostInventoryItemError>({
            ...options,
            url: '/inventory/item',
            responseTransformer: PostInventoryItemResponseTransformer
        });
    }
    
    /**
     * 🔒  [INV42] List item labels
     */
    public static getInventoryItemLabelsDocumenttypeDocumentid(options: Options<GetInventoryItemLabelsDocumenttypeDocumentidData>) {
        return (options?.client ?? client).get<GetInventoryItemLabelsDocumenttypeDocumentidResponse, GetInventoryItemLabelsDocumenttypeDocumentidError>({
            ...options,
            url: '/inventory/item-labels/{documentType}/{documentId}',
            responseTransformer: GetInventoryItemLabelsDocumenttypeDocumentidResponseTransformer
        });
    }
    
    /**
     * 🔒  [INV43] Print item labels
     */
    public static postInventoryItemLabelsDocumenttypeDocumentid(options: Options<PostInventoryItemLabelsDocumenttypeDocumentidData>) {
        return (options?.client ?? client).post<PostInventoryItemLabelsDocumenttypeDocumentidResponse, PostInventoryItemLabelsDocumenttypeDocumentidError>({
            ...options,
            url: '/inventory/item-labels/{documentType}/{documentId}'
        });
    }
    
    /**
     * 🔒  [INV32] Get item basic info
     */
    public static getInventoryItemLookupItemsku(options: Options<GetInventoryItemLookupItemskuData>) {
        return (options?.client ?? client).get<GetInventoryItemLookupItemskuResponse, GetInventoryItemLookupItemskuError>({
            ...options,
            url: '/inventory/item-lookup/{itemSku}'
        });
    }
    
    /**
     * 🔒  [INV210] List item tag options
     */
    public static getInventoryItemTagList(options?: Options) {
        return (options?.client ?? client).get<GetInventoryItemTagListResponse, GetInventoryItemTagListError>({
            ...options,
            url: '/inventory/item-tag/list'
        });
    }
    
    /**
     * 🔒  [INV10] Get item info
     */
    public static getInventoryItemItemsku(options: Options<GetInventoryItemItemskuData>) {
        return (options?.client ?? client).get<GetInventoryItemItemskuResponse, GetInventoryItemItemskuError>({
            ...options,
            url: '/inventory/item/{itemSku}',
            responseTransformer: GetInventoryItemItemskuResponseTransformer
        });
    }
    
    /**
     * 🔒  [INV45] Item batch list
     */
    public static getInventoryItemItemskuBatches(options: Options<GetInventoryItemItemskuBatchesData>) {
        return (options?.client ?? client).get<GetInventoryItemItemskuBatchesResponse, GetInventoryItemItemskuBatchesError>({
            ...options,
            url: '/inventory/item/{itemSku}/batches',
            responseTransformer: GetInventoryItemItemskuBatchesResponseTransformer
        });
    }
    
    /**
     * 🔒  [INV41] Item contact info upsert
     */
    public static postInventoryItemItemskuContactContactcode(options: Options<PostInventoryItemItemskuContactContactcodeData>) {
        return (options?.client ?? client).post<PostInventoryItemItemskuContactContactcodeResponse, PostInventoryItemItemskuContactContactcodeError>({
            ...options,
            url: '/inventory/item/{itemSku}/contact/{contactCode}'
        });
    }
    
    /**
     * Add item identifiers
     */
    public static postInventoryItemItemskuIdentifier(options: Options<PostInventoryItemItemskuIdentifierData>) {
        return (options?.client ?? client).post<PostInventoryItemItemskuIdentifierResponse, PostInventoryItemItemskuIdentifierError>({
            ...options,
            url: '/inventory/item/{itemSku}/identifier'
        });
    }
    
    /**
     * 🔒  [INV12] Get item images
     */
    public static getInventoryItemItemskuImages(options: Options<GetInventoryItemItemskuImagesData>) {
        return (options?.client ?? client).get<GetInventoryItemItemskuImagesResponse, GetInventoryItemItemskuImagesError>({
            ...options,
            url: '/inventory/item/{itemSku}/images'
        });
    }
    
    /**
     * 🔒  [INV20] Item images - Add
     */
    public static postInventoryItemItemskuImages(options: Options<PostInventoryItemItemskuImagesData>) {
        return (options?.client ?? client).post<PostInventoryItemItemskuImagesResponse, PostInventoryItemItemskuImagesError>({
            ...options,
            url: '/inventory/item/{itemSku}/images'
        });
    }
    
    /**
     * 🔒  [INV28] item inventory summary
     */
    public static getInventoryItemItemskuInventory(options: Options<GetInventoryItemItemskuInventoryData>) {
        return (options?.client ?? client).get<GetInventoryItemItemskuInventoryResponse, GetInventoryItemItemskuInventoryError>({
            ...options,
            url: '/inventory/item/{itemSku}/inventory'
        });
    }
    
    /**
     * 🔒  [INV31] Item inventory 3rd summary
     */
    public static getInventoryItemItemskuInventory3D(options: Options<GetInventoryItemItemskuInventory3DData>) {
        return (options?.client ?? client).get<GetInventoryItemItemskuInventory3DResponse, GetInventoryItemItemskuInventory3DError>({
            ...options,
            url: '/inventory/item/{itemSku}/inventory-3d',
            responseTransformer: GetInventoryItemItemskuInventory3DResponseTransformer
        });
    }
    
    /**
     * 🔒  [INV29] Get item inventory log
     */
    public static getInventoryItemItemskuInventoryLog(options: Options<GetInventoryItemItemskuInventoryLogData>) {
        return (options?.client ?? client).get<GetInventoryItemItemskuInventoryLogResponse, GetInventoryItemItemskuInventoryLogError>({
            ...options,
            url: '/inventory/item/{itemSku}/inventory-log',
            responseTransformer: GetInventoryItemItemskuInventoryLogResponseTransformer
        });
    }
    
    /**
     * 🔒  [INV33] Get item inventory drilldown
     */
    public static getInventoryItemItemskuInventoryDrilldownWarehouseid(options: Options<GetInventoryItemItemskuInventoryDrilldownWarehouseidData>) {
        return (options?.client ?? client).get<GetInventoryItemItemskuInventoryDrilldownWarehouseidResponse, GetInventoryItemItemskuInventoryDrilldownWarehouseidError>({
            ...options,
            url: '/inventory/item/{itemSku}/inventory/drilldown/{warehouseId}',
            responseTransformer: GetInventoryItemItemskuInventoryDrilldownWarehouseidResponseTransformer
        });
    }
    
    /**
     * 🔒  [INV13] Get item pricing
     */
    public static getInventoryItemItemskuPricing(options: Options<GetInventoryItemItemskuPricingData>) {
        return (options?.client ?? client).get<GetInventoryItemItemskuPricingResponse, GetInventoryItemItemskuPricingError>({
            ...options,
            url: '/inventory/item/{itemSku}/pricing',
            responseTransformer: GetInventoryItemItemskuPricingResponseTransformer
        });
    }
    
    /**
     * 🔒  [INV34] Get item quick-view summary
     */
    public static getInventoryItemItemskuQuickViewQvtype(options: Options<GetInventoryItemItemskuQuickViewQvtypeData>) {
        return (options?.client ?? client).get<GetInventoryItemItemskuQuickViewQvtypeResponse, GetInventoryItemItemskuQuickViewQvtypeError>({
            ...options,
            url: '/inventory/item/{itemSku}/quick-view/{qvType}',
            responseTransformer: GetInventoryItemItemskuQuickViewQvtypeResponseTransformer
        });
    }
    
    /**
     * 🔒  [INV27] Get item Uom
     */
    public static getInventoryItemItemskuUom(options: Options<GetInventoryItemItemskuUomData>) {
        return (options?.client ?? client).get<GetInventoryItemItemskuUomResponse, GetInventoryItemItemskuUomError>({
            ...options,
            url: '/inventory/item/{itemSku}/uom'
        });
    }
    
    /**
     * 🔒  [INV40] Item vendor upsert
     */
    public static postInventoryItemItemskuVendorContactcode(options: Options<PostInventoryItemItemskuVendorContactcodeData>) {
        return (options?.client ?? client).post<PostInventoryItemItemskuVendorContactcodeResponse, PostInventoryItemItemskuVendorContactcodeError>({
            ...options,
            url: '/inventory/item/{itemSku}/vendor/{contactCode}'
        });
    }
    
    /**
     * 🔒  [INV21] Item images - Upload
     * Only supports multipart/form-data
     */
    public static postInventoryItemImages(options?: Options<PostInventoryItemImagesData>) {
        return (options?.client ?? client).post<PostInventoryItemImagesResponse, PostInventoryItemImagesError>({
            ...options,
            ...formDataBodySerializer,
            url: '/inventory/item/images'
        });
    }
    
    /**
     * 🔒  [INV82] List items
     */
    public static getInventoryItemList(options?: Options<GetInventoryItemListData>) {
        return (options?.client ?? client).get<GetInventoryItemListResponse, GetInventoryItemListError>({
            ...options,
            url: '/inventory/item/list'
        });
    }
    
    /**
     * 🔒  [INV11] Item tags
     */
    public static patchInventoryItemTags(options?: Options<PatchInventoryItemTagsData>) {
        return (options?.client ?? client).patch<PatchInventoryItemTagsResponse, PatchInventoryItemTagsError>({
            ...options,
            url: '/inventory/item/tags'
        });
    }
    
    /**
     * 🔒  [INV18] Get price-list items
     */
    public static getInventoryPriceListId(options: Options<GetInventoryPriceListIdData>) {
        return (options?.client ?? client).get<GetInventoryPriceListIdResponse, GetInventoryPriceListIdError>({
            ...options,
            url: '/inventory/price-list/{id}',
            responseTransformer: GetInventoryPriceListIdResponseTransformer
        });
    }
    
    /**
     * 🔒  [INV17] List price-lists
     */
    public static getInventoryPriceListList(options?: Options) {
        return (options?.client ?? client).get<GetInventoryPriceListListResponse, GetInventoryPriceListListError>({
            ...options,
            url: '/inventory/price-list/list'
        });
    }
    
    /**
     * 🔒  [INV35] Pricelist Conditionals Upsert
     */
    public static postInventoryPriceListUpsertConditional(options?: Options<PostInventoryPriceListUpsertConditionalData>) {
        return (options?.client ?? client).post<PostInventoryPriceListUpsertConditionalResponse, PostInventoryPriceListUpsertConditionalError>({
            ...options,
            url: '/inventory/price-list/upsert/conditional'
        });
    }
    
    /**
     * 🔒  [INV37] Pricelist Upsert
     */
    public static postInventoryPriceListUpsertEntries(options?: Options<PostInventoryPriceListUpsertEntriesData>) {
        return (options?.client ?? client).post<PostInventoryPriceListUpsertEntriesResponse, PostInventoryPriceListUpsertEntriesError>({
            ...options,
            url: '/inventory/price-list/upsert/entries'
        });
    }
    
    /**
     * 🔒  [INV36] Pricelist Uom Upsert
     */
    public static postInventoryPriceListUpsertUom(options?: Options<PostInventoryPriceListUpsertUomData>) {
        return (options?.client ?? client).post<PostInventoryPriceListUpsertUomResponse, PostInventoryPriceListUpsertUomError>({
            ...options,
            url: '/inventory/price-list/upsert/uom'
        });
    }
    
    /**
     *  [INV14] Send item label to queue
     */
    public static postInventoryPrintItem(options?: Options<PostInventoryPrintItemData>) {
        return (options?.client ?? client).post<PostInventoryPrintItemResponse, PostInventoryPrintItemError>({
            ...options,
            url: '/inventory/print-item'
        });
    }
    
    /**
     *  [INV25] Send item label to queue (Bulk)
     */
    public static postInventoryPrintItemBulk(options?: Options<PostInventoryPrintItemBulkData>) {
        return (options?.client ?? client).post<PostInventoryPrintItemBulkResponse, PostInventoryPrintItemBulkError>({
            ...options,
            url: '/inventory/print-item-bulk'
        });
    }
    
    /**
     *  [INV22] List stock summary of items
     */
    public static getInventoryStockSummary(options?: Options<GetInventoryStockSummaryData>) {
        return (options?.client ?? client).get<GetInventoryStockSummaryResponse, GetInventoryStockSummaryError>({
            ...options,
            url: '/inventory/stock-summary',
            responseTransformer: GetInventoryStockSummaryResponseTransformer
        });
    }
    
    /**
     *  [INV23] List detailed stock summary of items
     * Get a stock summary of items, split by batch and bin location,  Results will not include un-batched and un-binned items. Results will not include zero quantity
     */
    public static getInventoryStockSummaryDetailed(options?: Options<GetInventoryStockSummaryDetailedData>) {
        return (options?.client ?? client).get<GetInventoryStockSummaryDetailedResponse, GetInventoryStockSummaryDetailedError>({
            ...options,
            url: '/inventory/stock-summary-detailed',
            responseTransformer: GetInventoryStockSummaryDetailedResponseTransformer
        });
    }
    
    /**
     *  [INV26] Create a stock transaction
     */
    public static postInventoryTrc(options?: Options<PostInventoryTrcData>) {
        return (options?.client ?? client).post<PostInventoryTrcResponse, PostInventoryTrcError>({
            ...options,
            url: '/inventory/trc'
        });
    }
    
    /**
     *  [INV24] Create a stock transfer
     */
    public static postInventoryTrn(options?: Options<PostInventoryTrnData>) {
        return (options?.client ?? client).post<PostInventoryTrnResponse, PostInventoryTrnError>({
            ...options,
            url: '/inventory/trn'
        });
    }
    
    /**
     * 🔒  [INVW01] Warehouses
     */
    public static getInventoryWarehouses(options?: Options<GetInventoryWarehousesData>) {
        return (options?.client ?? client).get<GetInventoryWarehousesResponse, GetInventoryWarehousesError>({
            ...options,
            url: '/inventory/warehouses'
        });
    }
    
    /**
     * 🔒  [INVW07] Warehouse bin upsert
     */
    public static postInventoryWarehousesWarehouseidBin(options: Options<PostInventoryWarehousesWarehouseidBinData>) {
        return (options?.client ?? client).post<PostInventoryWarehousesWarehouseidBinResponse, PostInventoryWarehousesWarehouseidBinError>({
            ...options,
            url: '/inventory/warehouses/{warehouseId}/bin'
        });
    }
    
    /**
     * 🔒  [INVW03] Warehouse bin list
     */
    public static getInventoryWarehousesWarehouseidBinList(options: Options<GetInventoryWarehousesWarehouseidBinListData>) {
        return (options?.client ?? client).get<GetInventoryWarehousesWarehouseidBinListResponse, GetInventoryWarehousesWarehouseidBinListError>({
            ...options,
            url: '/inventory/warehouses/{warehouseId}/bin-list'
        });
    }
    
    /**
     * 🔒  [INVW08] Warehouse bin delete
     */
    public static deleteInventoryWarehousesWarehouseidBinBinid(options: Options<DeleteInventoryWarehousesWarehouseidBinBinidData>) {
        return (options?.client ?? client).delete<DeleteInventoryWarehousesWarehouseidBinBinidResponse, DeleteInventoryWarehousesWarehouseidBinBinidError>({
            ...options,
            url: '/inventory/warehouses/{warehouseId}/bin/{binId}'
        });
    }
    
    /**
     * 🔒  [INVW02] Warehouse bins
     */
    public static getInventoryWarehousesWarehouseidBins(options: Options<GetInventoryWarehousesWarehouseidBinsData>) {
        return (options?.client ?? client).get<GetInventoryWarehousesWarehouseidBinsResponse, GetInventoryWarehousesWarehouseidBinsError>({
            ...options,
            url: '/inventory/warehouses/{warehouseId}/bins',
            responseTransformer: GetInventoryWarehousesWarehouseidBinsResponseTransformer
        });
    }
    
    /**
     * 🔒  [INVW05] Warehouse zone upsert
     */
    public static postInventoryWarehousesWarehouseidZone(options: Options<PostInventoryWarehousesWarehouseidZoneData>) {
        return (options?.client ?? client).post<PostInventoryWarehousesWarehouseidZoneResponse, PostInventoryWarehousesWarehouseidZoneError>({
            ...options,
            url: '/inventory/warehouses/{warehouseId}/zone'
        });
    }
    
    /**
     * 🔒  [INVW06] Warehouse zone delete
     */
    public static deleteInventoryWarehousesWarehouseidZoneZoneid(options: Options<DeleteInventoryWarehousesWarehouseidZoneZoneidData>) {
        return (options?.client ?? client).delete<DeleteInventoryWarehousesWarehouseidZoneZoneidResponse, DeleteInventoryWarehousesWarehouseidZoneZoneidError>({
            ...options,
            url: '/inventory/warehouses/{warehouseId}/zone/{zoneId}'
        });
    }
    
    /**
     * 🔒  [INVW04] Warehouse zones
     */
    public static getInventoryWarehousesWarehouseidZones(options: Options<GetInventoryWarehousesWarehouseidZonesData>) {
        return (options?.client ?? client).get<GetInventoryWarehousesWarehouseidZonesResponse, GetInventoryWarehousesWarehouseidZonesError>({
            ...options,
            url: '/inventory/warehouses/{warehouseId}/zones'
        });
    }
    
}

export class ReportsService {
    /**
     * Run custom feed
     */
    public static getReportsCustomFeedIdKey(options: Options<GetReportsCustomFeedIdKeyData>) {
        return (options?.client ?? client).get<GetReportsCustomFeedIdKeyResponse, GetReportsCustomFeedIdKeyError>({
            ...options,
            url: '/reports/custom-feed/{id}/{key}'
        });
    }
    
    /**
     * 🔒  [RPT13] KPI Dashboards
     */
    public static getReportsKpiDashboard(options?: Options) {
        return (options?.client ?? client).get<GetReportsKpiDashboardResponse, GetReportsKpiDashboardError>({
            ...options,
            url: '/reports/kpi-dashboard'
        });
    }
    
    /**
     * 🔒  [RPT32] KPI Dashboard - Create
     */
    public static postReportsKpiDashboard(options?: Options<PostReportsKpiDashboardData>) {
        return (options?.client ?? client).post<PostReportsKpiDashboardResponse, PostReportsKpiDashboardError>({
            ...options,
            url: '/reports/kpi-dashboard'
        });
    }
    
    /**
     * 🔒  [RPT50] KPI Dashboard upsert widget
     */
    public static postReportsKpiDashboardDashboardidWidget(options: Options<PostReportsKpiDashboardDashboardidWidgetData>) {
        return (options?.client ?? client).post<PostReportsKpiDashboardDashboardidWidgetResponse, PostReportsKpiDashboardDashboardidWidgetError>({
            ...options,
            url: '/reports/kpi-dashboard/{dashboardId}/widget'
        });
    }
    
    /**
     * 🔒  [RPT50] KPI Dashboard upsert widget
     */
    public static postReportsKpiDashboardDashboardidWidgetWidgetid(options: Options<PostReportsKpiDashboardDashboardidWidgetWidgetidData>) {
        return (options?.client ?? client).post<PostReportsKpiDashboardDashboardidWidgetWidgetidResponse, PostReportsKpiDashboardDashboardidWidgetWidgetidError>({
            ...options,
            url: '/reports/kpi-dashboard/{dashboardId}/widget/{widgetId}'
        });
    }
    
    /**
     * 🔒  [RPT52] KPI Dashboard delete widget
     */
    public static deleteReportsKpiDashboardDashboardidWidgetWidgetid(options: Options<DeleteReportsKpiDashboardDashboardidWidgetWidgetidData>) {
        return (options?.client ?? client).delete<DeleteReportsKpiDashboardDashboardidWidgetWidgetidResponse, DeleteReportsKpiDashboardDashboardidWidgetWidgetidError>({
            ...options,
            url: '/reports/kpi-dashboard/{dashboardId}/widget/{widgetId}'
        });
    }
    
    /**
     * 🔒  [RPT51] KPI Dashboard list widget
     */
    public static getReportsKpiDashboardDashboardidWidgets(options: Options<GetReportsKpiDashboardDashboardidWidgetsData>) {
        return (options?.client ?? client).get<GetReportsKpiDashboardDashboardidWidgetsResponse, GetReportsKpiDashboardDashboardidWidgetsError>({
            ...options,
            url: '/reports/kpi-dashboard/{dashboardId}/widgets'
        });
    }
    
    /**
     * 🔒  [RPT33] KPI Dashboard - Update
     */
    public static putReportsKpiDashboardId(options: Options<PutReportsKpiDashboardIdData>) {
        return (options?.client ?? client).put<PutReportsKpiDashboardIdResponse, PutReportsKpiDashboardIdError>({
            ...options,
            url: '/reports/kpi-dashboard/{id}'
        });
    }
    
    /**
     * 🔒  [RPT34] KPI Dashboard - Delete
     */
    public static deleteReportsKpiDashboardId(options: Options<DeleteReportsKpiDashboardIdData>) {
        return (options?.client ?? client).delete<DeleteReportsKpiDashboardIdResponse, DeleteReportsKpiDashboardIdError>({
            ...options,
            url: '/reports/kpi-dashboard/{id}'
        });
    }
    
    /**
     * 🔓  [RPT15] KPI Dashboard
     */
    public static getReportsKpiDashboardToken(options: Options<GetReportsKpiDashboardTokenData>) {
        return (options?.client ?? client).get<GetReportsKpiDashboardTokenResponse, GetReportsKpiDashboardTokenError>({
            ...options,
            url: '/reports/kpi-dashboard/{token}'
        });
    }
    
    /**
     * 🔓  [RPT20] KPI Widget value
     */
    public static getReportsKpiDashboardTokenValueWidgetid(options: Options<GetReportsKpiDashboardTokenValueWidgetidData>) {
        return (options?.client ?? client).get<GetReportsKpiDashboardTokenValueWidgetidResponse, GetReportsKpiDashboardTokenValueWidgetidError>({
            ...options,
            url: '/reports/kpi-dashboard/{token}/value/{widgetId}'
        });
    }
    
    /**
     * 🔓  [RPT19] KPI Dashboard update widgets position
     */
    public static putReportsKpiDashboardTokenWidgets(options: Options<PutReportsKpiDashboardTokenWidgetsData>) {
        return (options?.client ?? client).put<PutReportsKpiDashboardTokenWidgetsResponse, PutReportsKpiDashboardTokenWidgetsError>({
            ...options,
            url: '/reports/kpi-dashboard/{token}/widgets'
        });
    }
    
    /**
     * 🔓 List widget types
     */
    public static getReportsKpiDashboardListWidgetTypes(options?: Options) {
        return (options?.client ?? client).get<GetReportsKpiDashboardListWidgetTypesResponse, GetReportsKpiDashboardListWidgetTypesError>({
            ...options,
            url: '/reports/kpi-dashboard/list-widget-types'
        });
    }
    
    /**
     * 🔒 List report types
     */
    public static getReportsListTypes(options?: Options) {
        return (options?.client ?? client).get<GetReportsListTypesResponse, GetReportsListTypesError>({
            ...options,
            url: '/reports/list-types'
        });
    }
    
    /**
     * Report server - Items
     */
    public static getReportsReportServerItems(options: Options<GetReportsReportServerItemsData>) {
        return (options?.client ?? client).get<GetReportsReportServerItemsResponse, GetReportsReportServerItemsError>({
            ...options,
            url: '/reports/report-server/items'
        });
    }
    
    /**
     *  [RPT30] Report server - Sales
     */
    public static getReportsReportServerSales(options: Options<GetReportsReportServerSalesData>) {
        return (options?.client ?? client).get<GetReportsReportServerSalesResponse, GetReportsReportServerSalesError>({
            ...options,
            url: '/reports/report-server/sales'
        });
    }
    
    /**
     * 🔒 Run report
     */
    public static postReportsRunReport(options?: Options<PostReportsRunReportData>) {
        return (options?.client ?? client).post<PostReportsRunReportResponse, PostReportsRunReportError>({
            ...options,
            url: '/reports/run-report'
        });
    }
    
    /**
     * 🔒 Sales report drill down
     */
    public static getReportsSalesDrillDownItemsku(options: Options<GetReportsSalesDrillDownItemskuData>) {
        return (options?.client ?? client).get<GetReportsSalesDrillDownItemskuResponse, GetReportsSalesDrillDownItemskuError>({
            ...options,
            url: '/reports/sales-drill-down/{itemSku}',
            responseTransformer: GetReportsSalesDrillDownItemskuResponseTransformer
        });
    }
    
    /**
     * 🔒  [RPT12] Get sales top performance by section
     */
    public static getReportsSalesOverviewPerformanceSection(options: Options<GetReportsSalesOverviewPerformanceSectionData>) {
        return (options?.client ?? client).get<GetReportsSalesOverviewPerformanceSectionResponse, GetReportsSalesOverviewPerformanceSectionError>({
            ...options,
            url: '/reports/sales-overview/performance/{section}'
        });
    }
    
    /**
     * 🔒  [RPT17] Get sales performance for each day
     */
    public static getReportsSalesOverviewPerformanceDaily(options: Options<GetReportsSalesOverviewPerformanceDailyData>) {
        return (options?.client ?? client).get<GetReportsSalesOverviewPerformanceDailyResponse, GetReportsSalesOverviewPerformanceDailyError>({
            ...options,
            url: '/reports/sales-overview/performance/daily'
        });
    }
    
    /**
     * 🔒  [RPT11] Get sales top performing items
     */
    public static getReportsSalesOverviewPerformanceItems(options: Options<GetReportsSalesOverviewPerformanceItemsData>) {
        return (options?.client ?? client).get<GetReportsSalesOverviewPerformanceItemsResponse, GetReportsSalesOverviewPerformanceItemsError>({
            ...options,
            url: '/reports/sales-overview/performance/items'
        });
    }
    
    /**
     * 🔒  [RPT25] Get sales overview summary
     */
    public static getReportsSalesOverviewSummary(options: Options<GetReportsSalesOverviewSummaryData>) {
        return (options?.client ?? client).get<GetReportsSalesOverviewSummaryResponse, GetReportsSalesOverviewSummaryError>({
            ...options,
            url: '/reports/sales-overview/summary'
        });
    }
    
    /**
     * 🔒  [RPT26] Get sales overview summary by preset date range
     */
    public static getReportsSalesOverviewSummaryRange(options: Options<GetReportsSalesOverviewSummaryRangeData>) {
        return (options?.client ?? client).get<GetReportsSalesOverviewSummaryRangeResponse, GetReportsSalesOverviewSummaryRangeError>({
            ...options,
            url: '/reports/sales-overview/summary/{range}',
            responseTransformer: GetReportsSalesOverviewSummaryRangeResponseTransformer
        });
    }
    
    /**
     * 🔒 Scheduled reports - List
     */
    public static getReportsSchedules(options?: Options) {
        return (options?.client ?? client).get<GetReportsSchedulesResponse, GetReportsSchedulesError>({
            ...options,
            url: '/reports/schedules',
            responseTransformer: GetReportsSchedulesResponseTransformer
        });
    }
    
    /**
     * 🔒 Scheduled reports - Create
     */
    public static postReportsSchedules(options?: Options<PostReportsSchedulesData>) {
        return (options?.client ?? client).post<PostReportsSchedulesResponse, PostReportsSchedulesError>({
            ...options,
            url: '/reports/schedules'
        });
    }
    
    /**
     * 🔒 Scheduled reports - Details
     */
    public static getReportsSchedulesId(options: Options<GetReportsSchedulesIdData>) {
        return (options?.client ?? client).get<GetReportsSchedulesIdResponse, GetReportsSchedulesIdError>({
            ...options,
            url: '/reports/schedules/{id}',
            responseTransformer: GetReportsSchedulesIdResponseTransformer
        });
    }
    
    /**
     * 🔒 Scheduled reports - Update
     */
    public static patchReportsSchedulesId(options: Options<PatchReportsSchedulesIdData>) {
        return (options?.client ?? client).patch<PatchReportsSchedulesIdResponse, PatchReportsSchedulesIdError>({
            ...options,
            url: '/reports/schedules/{id}'
        });
    }
    
    /**
     * 🔒 Scheduled reports - Delete
     */
    public static deleteReportsSchedulesId(options: Options<DeleteReportsSchedulesIdData>) {
        return (options?.client ?? client).delete<DeleteReportsSchedulesIdResponse, DeleteReportsSchedulesIdError>({
            ...options,
            url: '/reports/schedules/{id}'
        });
    }
    
    /**
     * 🔒 SO heat-map report
     */
    public static getReportsSoCustomerPeriodicSoid(options: Options<GetReportsSoCustomerPeriodicSoidData>) {
        return (options?.client ?? client).get<GetReportsSoCustomerPeriodicSoidResponse, GetReportsSoCustomerPeriodicSoidError>({
            ...options,
            url: '/reports/so-customer-periodic/{soId}',
            responseTransformer: GetReportsSoCustomerPeriodicSoidResponseTransformer
        });
    }
    
    /**
     * 🔒  [RPT23] Mark system alerts as dismissed for an entire group
     */
    public static putReportsSystemAlertsDismissGroup(options: Options<PutReportsSystemAlertsDismissGroupData>) {
        return (options?.client ?? client).put<PutReportsSystemAlertsDismissGroupResponse, PutReportsSystemAlertsDismissGroupError>({
            ...options,
            url: '/reports/system-alerts/dismiss-group'
        });
    }
    
    /**
     * 🔒  [RPT24] Mark system alert as dismissed by alert id
     */
    public static putReportsSystemAlertsDismissMessage(options: Options<PutReportsSystemAlertsDismissMessageData>) {
        return (options?.client ?? client).put<PutReportsSystemAlertsDismissMessageResponse, PutReportsSystemAlertsDismissMessageError>({
            ...options,
            url: '/reports/system-alerts/dismiss-message'
        });
    }
    
    /**
     * 🔒  [RPT21] List system alerts grouped by type
     */
    public static getReportsSystemAlertsGroups(options?: Options) {
        return (options?.client ?? client).get<GetReportsSystemAlertsGroupsResponse, GetReportsSystemAlertsGroupsError>({
            ...options,
            url: '/reports/system-alerts/groups',
            responseTransformer: GetReportsSystemAlertsGroupsResponseTransformer
        });
    }
    
    /**
     * 🔒  [RPT22] List system alert messages within a group
     */
    public static getReportsSystemAlertsMessages(options: Options<GetReportsSystemAlertsMessagesData>) {
        return (options?.client ?? client).get<GetReportsSystemAlertsMessagesResponse, GetReportsSystemAlertsMessagesError>({
            ...options,
            url: '/reports/system-alerts/messages',
            responseTransformer: GetReportsSystemAlertsMessagesResponseTransformer
        });
    }
    
}

export class SettingsService {
    /**
     * 🔒 List Api Users
     */
    public static getSettingsApiUsers(options?: Options) {
        return (options?.client ?? client).get<GetSettingsApiUsersResponse, GetSettingsApiUsersError>({
            ...options,
            url: '/settings/api-users'
        });
    }
    
    /**
     * 🔒 List currencies
     */
    public static getSettingsCurrencyList(options?: Options) {
        return (options?.client ?? client).get<GetSettingsCurrencyListResponse, GetSettingsCurrencyListError>({
            ...options,
            url: '/settings/currency/list'
        });
    }
    
    /**
     * 🔒 List Custom Fields
     */
    public static getSettingsDocumentCustomField(options: Options<GetSettingsDocumentCustomFieldData>) {
        return (options?.client ?? client).get<GetSettingsDocumentCustomFieldResponse, GetSettingsDocumentCustomFieldError>({
            ...options,
            url: '/settings/document-custom-field'
        });
    }
    
    /**
     * 🔒 List document stages
     */
    public static getSettingsDocumentStageList(options?: Options) {
        return (options?.client ?? client).get<GetSettingsDocumentStageListResponse, GetSettingsDocumentStageListError>({
            ...options,
            url: '/settings/document-stage/list'
        });
    }
    
    /**
     * 🔒 Create document tag
     */
    public static postSettingsDocumentTag(options?: Options<PostSettingsDocumentTagData>) {
        return (options?.client ?? client).post<PostSettingsDocumentTagResponse, PostSettingsDocumentTagError>({
            ...options,
            url: '/settings/document-tag'
        });
    }
    
    /**
     * 🔒 Update document tag
     */
    public static putSettingsDocumentTagId(options: Options<PutSettingsDocumentTagIdData>) {
        return (options?.client ?? client).put<PutSettingsDocumentTagIdResponse, PutSettingsDocumentTagIdError>({
            ...options,
            url: '/settings/document-tag/{id}'
        });
    }
    
    /**
     * 🔒 List document tags
     */
    public static getSettingsDocumentTagList(options?: Options) {
        return (options?.client ?? client).get<GetSettingsDocumentTagListResponse, GetSettingsDocumentTagListError>({
            ...options,
            url: '/settings/document-tag/list'
        });
    }
    
}

export class UserService {
    /**
     * 🔒  [USR09] Columns display settings
     */
    public static getUserDataColumnsViewname(options: Options<GetUserDataColumnsViewnameData>) {
        return (options?.client ?? client).get<GetUserDataColumnsViewnameResponse, GetUserDataColumnsViewnameError>({
            ...options,
            url: '/user/data-columns/{viewName}'
        });
    }
    
    /**
     * 🔒  [USR23] Request email validation
     */
    public static postUserEmailValidationRequest(options?: Options) {
        return (options?.client ?? client).post<PostUserEmailValidationRequestResponse, PostUserEmailValidationRequestError>({
            ...options,
            url: '/user/email-validation-request'
        });
    }
    
    /**
     * 🔒  [USR26] User notifications
     */
    public static getUserNotifications(options?: Options<GetUserNotificationsData>) {
        return (options?.client ?? client).get<GetUserNotificationsResponse, GetUserNotificationsError>({
            ...options,
            url: '/user/notifications',
            responseTransformer: GetUserNotificationsResponseTransformer
        });
    }
    
    /**
     * 🔒  [USR25] User notifications count
     */
    public static getUserNotificationsCount(options?: Options) {
        return (options?.client ?? client).get<GetUserNotificationsCountResponse, GetUserNotificationsCountError>({
            ...options,
            url: '/user/notifications-count'
        });
    }
    
    /**
     *  [USR10] Organization information
     */
    public static getUserOrganization(options?: Options) {
        return (options?.client ?? client).get<GetUserOrganizationResponse, GetUserOrganizationError>({
            ...options,
            url: '/user/organization'
        });
    }
    
    /**
     *  [USR08] User information
     */
    public static getUserSelf(options?: Options) {
        return (options?.client ?? client).get<GetUserSelfResponse, GetUserSelfError>({
            ...options,
            url: '/user/self'
        });
    }
    
    /**
     * 🔒  [US24] Support ticket
     */
    public static postUserSupportTicket(options?: Options<PostUserSupportTicketData>) {
        return (options?.client ?? client).post<PostUserSupportTicketResponse, PostUserSupportTicketError>({
            ...options,
            ...formDataBodySerializer,
            url: '/user/support-ticket'
        });
    }
    
    /**
     * 🔒  [USR22] Get user support ticket
     */
    public static getUserSupportTicketTicketid(options: Options<GetUserSupportTicketTicketidData>) {
        return (options?.client ?? client).get<GetUserSupportTicketTicketidResponse, GetUserSupportTicketTicketidError>({
            ...options,
            url: '/user/support-ticket/{ticketId}',
            responseTransformer: GetUserSupportTicketTicketidResponseTransformer
        });
    }
    
    /**
     * 🔒  [USR21] List support tickets
     */
    public static getUserSupportTicketList(options?: Options<GetUserSupportTicketListData>) {
        return (options?.client ?? client).get<GetUserSupportTicketListResponse, GetUserSupportTicketListError>({
            ...options,
            url: '/user/support-ticket/list',
            responseTransformer: GetUserSupportTicketListResponseTransformer
        });
    }
    
}